import { AggregationTranslation } from '@/types/virtual-search/filters';
import { MblEntity } from '@/types/mbl/mbl.entity';

export const MblVirtualFilterTranslation = (): AggregationTranslation<MblEntity> => ({
  // @ts-ignore
  'destinationWarehouse.accountName.keyword': {
    type: 'select',
    label: 'Destination Warehouse',
    value: 'destinationWarehouse.accountName.keyword',
  },
  'status.keyword': {
    type: 'select',
    label: 'Status',
    value: 'status.keyword',
  },
  isReady: {
    type: 'boolean',
    label: 'Ready',
    value: 'isReady',
  },
  'fileSource.keyword': {
    type: 'select',
    label: 'File Source',
    value: 'fileSource.keyword',
  },
  'packageType.description.keyword': {
    type: 'select',
    label: 'Package Type',
    value: 'packageType.description.keyword',
  },
  isViewed: {
    type: 'boolean',
    label: 'Viewed',
    value: 'isViewed',
  },
  isFinalized: {
    type: 'boolean',
    label: 'Finalized',
    value: 'isFinalized',
  },
  'warehouse.accountName.keyword': {
    type: 'select',
    label: 'Warehouse',
    value: 'warehouse.accountName.keyword',
  },
  isPttRequired: {
    type: 'boolean',
    label: 'PTT Required',
    value: 'isPttRequired',
  },
  warehouseCollectCommissionProcessed: {
    type: 'boolean',
    label: 'Collect Commission Processed',
    value: 'warehouseCollectCommissionProcessed',
  },
  hazmat: {
    type: 'boolean',
    label: 'Hazmat',
    value: 'hazmat',
  },
  'emptyReturnLocation.accountName.keyword': {
    type: 'select',
    label: 'Empty Return Location',
    value: 'emptyReturnLocation.accountName.keyword',
  },
  'carrier.accountName.keyword': {
    type: 'select',
    label: 'Carrier',
    value: 'carrier.accountName.keyword',
  },
  headLoad: {
    type: 'boolean',
    label: 'Head Load',
    value: 'headLoad',
  },
  customerCommissionProcessed: {
    type: 'boolean',
    label: 'Customer Commission Processed',
    value: 'customerCommissionProcessed',
  },
  'service.description.keyword': {
    type: 'select',
    label: 'Service',
    value: 'service.description.keyword',
  },
  'paymentLookup.description.keyword': {
    type: 'select',
    label: 'Payment Lookup',
    value: 'paymentLookup.description.keyword',
  },
  'containerType.description.keyword': {
    type: 'select',
    label: 'Container Type',
    value: 'containerType.description.keyword',
  },
  'vessel.vessel_name.keyword': {
    type: 'select',
    label: 'Vessel',
    value: 'vessel.vessel_name.keyword',
  },
  'pod.description.keyword': {
    type: 'select',
    label: 'POD',
    value: 'pod.description.keyword',
  },
  'loadType.keyword': {
    type: 'select',
    label: 'Load Type',
    value: 'loadType.keyword',
  },
  isIpiReceiveLoad: {
    type: 'boolean',
    label: 'IPI Receive',
    value: 'isIpiReceiveLoad',
  },
  'pol.description.keyword': {
    type: 'select',
    label: 'POL',
    value: 'pol.description.keyword',
  },
  isClosed: {
    type: 'boolean',
    label: 'Closed',
    value: 'isClosed',
  },
  'pickupCarrier.accountName.keyword': {
    type: 'select',
    label: 'Pickup Carrier',
    value: 'pickupCarrier.accountName.keyword',
  },
  'customer.accountName.keyword': {
    type: 'select',
    label: 'Customer',
    value: 'customer.accountName.keyword',
  },
  'terminal.accountName.keyword': {
    type: 'select',
    label: 'Terminal',
    value: 'terminal.accountName.keyword',
  },
  'pttCustomStatus.keyword': {
    type: 'select',
    label: 'PTT Custom Status',
    value: 'pttCustomStatus.keyword',
  },
});

export const MblVirtualFilterAdditionalOption = (): AggregationTranslation<Record<any, any>> => ({
  containerNumber: {
    type: 'text',
    label: 'Container #',
    value: 'containerNumber',
  },
  custRef: {
    type: 'text',
    label: 'Customer Reference #',
    value: 'custRef',
  },
  sealNumber: {
    type: 'text',
    label: 'Seal #',
    value: 'sealNumber',
  },
  chassis: {
    type: 'text',
    label: 'Chassis #',
    value: 'chassis',
  },
  mblNumber: {
    type: 'text',
    label: 'MBL #',
    value: 'mblNumber',
  },
  mib: {
    type: 'text',
    label: 'MIB #',
    value: 'mib',
  },
  tir: {
    type: 'text',
    label: 'TIR #',
    value: 'tir',
  },
  shipmentNumber: {
    type: 'text',
    label: 'Shipment #',
    value: 'shipmentNumber',
  },
  door: {
    type: 'text',
    label: 'Door #',
    value: 'door',
  },
  pttBatchNumber: {
    type: 'text',
    label: 'PTT Batch #',
    value: 'pttBatchNumber',
  },
  deliveryNotes: {
    type: 'text',
    label: 'Delivery Notes',
    value: 'deliveryNotes',
  },
  strippedBy: {
    type: 'text',
    label: 'Stripped By',
    value: 'strippedBy',
  },
  cfsLocation: {
    type: 'text',
    label: 'CFS Location',
    value: 'cfsLocation',
  },
  cargoDescription: {
    type: 'text',
    label: 'Cargo Description',
    value: 'cargoDescription',
  },
  voyage: {
    type: 'text',
    label: 'Voyage',
    value: 'voyage',
  },
  eta: {
    type: 'date',
    label: 'ETA',
    value: 'eta',
  },
  terminalDispatchDate: {
    type: 'date',
    label: 'Dispatch Date',
    value: 'terminalDispatchDate',
  },
  dischargeDate: {
    type: 'date',
    label: 'Discharge Date',
    value: 'dischargeDate',
  },
  stripDate: {
    type: 'date',
    label: 'Strip Date',
    value: 'stripDate',
  },
  pttRequiredDate: {
    type: 'date',
    label: 'PTT Submitted Date',
    value: 'pttRequiredDate',
  },
  pttApprovalDate: {
    type: 'date',
    label: 'PTT Approved Date',
    value: 'pttApprovalDate',
  },
  documentReceivedDate: {
    type: 'date',
    label: 'Document Received Date',
    value: 'documentReceivedDate',
  },
});

export const MblVirtualFilterDefaultForm = (layout?: string) => {
  const base = {
    'status.keyword': [],
  };
  if (layout === 'tablet') {
    return {
      ...base,
      shipmentNumber: '',
      containerNumber: '',
    };
  }
  return base;
};
